import React, { Component } from 'react';
import { onScrollElemento } from '../modules/util';



class Counter extends Component {

    state = {
        tempoInit: 0,
        tempoTotal: 7000,
        contador: 0,
        ativo: false
    }

    componentDidMount() {
        this.setState({
            ativo: true,
            tempoInit: Date.now()
        });
        this.incrementa();
    }

    componentWillUnmount(){
        this.state.ativo = false;
    }

    incrementa() {
        window.setTimeout(() => {
            if(!this.state.ativo){
                return;
            }
           
            if (this.state.contador < this.props.total) {
                var tempoGasto = Date.now() - this.state.tempoInit;
                this.setState({
                    contador: Math.floor((tempoGasto * this.props.total) / this.state.tempoTotal)
                });
                this.incrementa();
            } else {
                this.setState({
                    contador: this.props.total
                });
            }
        }, 17);
    }


    render() {
        return (
            <div className="counter">
                <label>{this.state.contador.toLocaleString()}</label>
            </div>
        );
    }
}

export default Counter;



// WEBPACK FOOTER //
// ./src/js/components/counter.js